import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import SeoHead from '@/components/feature/SeoHead';
import BackToTop from '@/components/feature/BackToTop';
import PageHero from '@/components/feature/PageHero';
import CooperationIntro from '@/pages/cooperation/components/CooperationIntro';
import CooperationTypes from '@/pages/cooperation/components/CooperationTypes';
import CooperationFlow from '@/pages/cooperation/components/CooperationFlow';
import CooperationFormSection from '@/pages/cooperation/components/CooperationFormSection';
import { cooperationTypes } from '@/mocks/siteData';

const cooperationStructuredData = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '商务合作｜深瞳爆料官网',
    url: 'https://shentong-baoliao.com/cooperation',
    inLanguage: 'zh-CN',
    description:
      '深瞳爆料官网商务合作页面，说明转载授权、联合调查、数据研究、内容共建与安全技术协作五类合作方式及申请流程。',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://shentong-baoliao.com/' },
      {
        '@type': 'ListItem',
        position: 2,
        name: '商务合作',
        item: 'https://shentong-baoliao.com/cooperation',
      },
    ],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: '深瞳爆料合作方式',
    itemListElement: cooperationTypes.map((type, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: type.title,
      description: type.desc,
    })),
  },
];

export default function CooperationPage() {
  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <SeoHead
        title="商务合作｜转载授权与联合调查 - 深瞳爆料官网"
        description="深瞳爆料官网商务合作通道：内容转载授权、联合调查协作、数据与研究合作、品牌内容共建与安全技术协作，说明合作类型、申请流程、四条合作边界与商务对接邮箱。"
        keywords="爆料官网商务合作,内容转载授权,联合调查,数据合作,商务合作邮箱"
        path="/cooperation"
        structuredData={cooperationStructuredData}
      />
      <SiteHeader />
      <main className="flex-1">
        <PageHero
          kicker="Business & Media"
          title="商务合作与联合调查"
          description="我们与机构媒体、研究机构、内容平台和安全团队协作，把单条线索推进为可被验证的公共信息。合作以不损害信源安全与议题独立性为前提。"
          crumbs={[{ label: '首页', to: '/' }, { label: '商务合作' }]}
        />
        <CooperationIntro />
        <CooperationTypes />
        <CooperationFlow />
        <CooperationFormSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}